module.exports = __webpack_public_path__ + "./img/clipboard.42c27614a26df9f1ed94754b02cb85a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/clipboard.png
// module id = ./assets/images/clipboard.png
// module chunks = 0